


















import Vue from 'vue'

export default Vue.extend({
  name: 'QuestionDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    label: String
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onNoButtonClick (): void {
      this.$emit('close')
    },

    onYesButtonClick (): void {
      this.$emit('save')
    }
  }
})
